import { Button } from "@/components/ui/button";

interface StepNavigationProps {
  isFirstStep: boolean;
  isLastStep: boolean;
  onBack: () => void;
  onNext: () => void;
  onComplete: () => void;
  loading: boolean;
  showNext?: boolean;
}

export const StepNavigation = ({
  isFirstStep,
  isLastStep,
  onBack,
  onNext,
  onComplete,
  loading,
  showNext = true,
}: StepNavigationProps) => {
  return (
    <div className="flex justify-between mt-12">
      {!isFirstStep && (
        <Button
          variant="outline"
          onClick={onBack}
          disabled={loading}
        >
          Back
        </Button>
      )}
      {!isLastStep && showNext && (
        <Button
          variant="outline"
          onClick={onNext}
          disabled={loading}
          className="ml-auto"
        >
          Next
        </Button>
      )}
      {isLastStep && (
        <Button
          variant="secondary"
          onClick={onComplete}
          disabled={loading}
          className="ml-auto"
        >
          {loading ? "Creating Profile..." : "Complete"}
        </Button>
      )}
    </div>
  );
};